<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات نظر مشتری"
        >
          <b-form
            ref="opinionform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>
                  <b-col
                    class="image"
                    cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                          ref="previewEl"
                          :src="Form.Image"
                          size="90px"
                          rounded
                          button
                          @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                        :ref="'refInputEl'"
                        type="file"
                        class="d-none"
                        name="Image"
                        @input="imageRenderer($event)"
                      >
                    </b-media>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <div class="form-label-group">
                        <b-form-textarea
                          id="Description"
                          v-model="Form.Description"
                          name="Description"
                          rows="5"
                        />
                      </div>
                    </b-form-group>

                  </b-col>

                  <b-col
                    cols="12"
                    class="mt-1"
                  >
                    <b-form-group>
                      <b-form-checkbox
                        v-model="Form.Visibility"
                        name="Visibility"
                        value="true"
                        class="custom-control-success"
                      >
                        برای کاربر نمایش داده شود؟
                      </b-form-checkbox>

                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <div class="divider divider-solid">
                      <div
                        class="divider-text"
                        style="font-weight: 600;"
                      >
                        مشتری
                      </div>
                    </div>
                  </b-col>

                  <b-col
                    class="image"
                    cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                          ref="previewEl2"
                          :src="Form.CustomerImage"
                          size="90px"
                          rounded
                          button
                          @click="$refs.refInputEl2.click()"
                        />
                      </template>
                      <input
                        :ref="'refInputEl2'"
                        type="file"
                        class="d-none"
                        name="CustomerImage"
                        @input="imageRenderer2($event)"
                      >
                      <b-row>
                        <b-col md="12">
                          <b-form-group
                            label="نام مشتری"
                            label-for="CustomerName"
                            class="mb-0"
                          >
                            <b-form-input
                              id="Title"
                              v-model="Form.CustomerName"
                              name="CustomerName"
                              autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
export default {
  name: 'OpinionDetails',
  components: {},
  data() {
    return {
      Form: {
        Id: null,
        CustomerName: null,
        CustomerImage: null,
        Image: null,
        Description: null,
        Visibility: true,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.opinion.add
      if (this.$route.params.id) {
        url = this.$api.opinion.update
      }

      this.loading = true

      const formData = new FormData(this.$refs.opinionform)
      formData.append('Id', this.Form.Id)

      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.opinion.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    imageRenderer2(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.CustomerImage = fileReader.result
      }
    },
  },
}
</script>

<style scoped>
.image .media-body {
    align-self: flex-end;
}
</style>
